import { useEffect, useState, useReducer } from "react";
import Select from "react-select";

function UserDropdown({ users, user, onChange, shares }) {
  // Filter users who are already inside of shares out of users
  const [options, setOptions] = useState([]);

  useEffect(() => {

    let val = [];

    if (!shares) {
      shares = [];
    }
    if(!users){
      users = [];
    }

    users.forEach((user) => {
      // Check if user.email is in shares
      let found = false;
      shares.forEach((share) => {
        if (share.share_user_email == user.email) {
          found = true;
        }
      });
      if (
        !found &&
        typeof user.share_user_id !== "undefined" &&
        typeof user.email !== "undefined"
      ) {
        val.push({ value: user.share_user_id, label: user.email });
      }
    });

    let sortedOptions = val.sort(compare);
    setOptions(sortedOptions);


  }, [users, shares, user]);

  function compare(a, b) {
    return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
  }

  return (
    <Select
      placeholder="Select user"
      aria-label="Select User"
      value={user}
      onChange={onChange}
      options={options}
    />
  );
}

export default UserDropdown;
